/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementAction,
  AgreementActionOptional,
  AgreementActionMetaI,
  AgreementActionTrackedI,
} from "./agreement-action";
import {
  AgreementActionTracked,
  AgreementActionMeta,
} from "./agreement-action";
// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementInstanceRef,
  AgreementInstanceRefOptional,
  AgreementInstanceRefMetaI,
  AgreementInstanceRefTrackedI,
} from "./agreement-instance-ref";
import {
  AgreementInstanceRefTracked,
  AgreementInstanceRefMeta,
} from "./agreement-instance-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  AgreementRef,
  AgreementRefOptional,
  AgreementRefMetaI,
  AgreementRefTrackedI,
} from "./agreement-ref";
import { AgreementRefTracked, AgreementRefMeta } from "./agreement-ref";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonAgreementInstanceInternal,
  PersonAgreementInstanceInternalOptional,
  PersonAgreementInstanceInternalMetaI,
  PersonAgreementInstanceInternalTrackedI,
} from "./person-agreement-instance-internal";
import {
  PersonAgreementInstanceInternalTracked,
  PersonAgreementInstanceInternalMeta,
} from "./person-agreement-instance-internal";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonRef,
  PersonRefOptional,
  PersonRefMetaI,
  PersonRefTrackedI,
} from "./person-ref";
import { PersonRefTracked, PersonRefMeta } from "./person-ref";

/**
 *
 * @export
 * @interface PersonAgreementInstanceDTO
 */
export interface PersonAgreementInstanceDTOOptional extends PersonAgreementInstanceInternalOptional {
  /**
   *
   * @type {number}
   * @memberof PersonAgreementInstanceDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  prefix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  middle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  suffix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  preferred?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  organization?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  agreedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  agreementExpiration?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  ipAddress?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  userAgent?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  email?: string;
  /**
   *
   * @type {AgreementAction}
   * @memberof PersonAgreementInstanceDTO
   */
  agreementAction?: AgreementAction;
  /**
   *
   * @type {boolean}
   * @memberof PersonAgreementInstanceDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonAgreementInstanceDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {AgreementInstanceRef}
   * @memberof PersonAgreementInstanceDTO
   */
  agreementInstanceId?: AgreementInstanceRefOptional;
  /**
   *
   * @type {AgreementRef}
   * @memberof PersonAgreementInstanceDTO
   */
  agreementId?: AgreementRefOptional;
  /**
   *
   * @type {PersonRef}
   * @memberof PersonAgreementInstanceDTO
   */
  personId?: PersonRefOptional;
}

export interface PersonAgreementInstanceDTO
  extends PersonAgreementInstanceDTOOptional, PersonAgreementInstanceInternal {
  /**
   *
   * @type {number}
   * @memberof PersonAgreementInstanceDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  prefix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  middle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  suffix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  preferred?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  organization?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  agreedOn?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  agreementExpiration?: Date;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  ipAddress?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  userAgent?: string;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  email?: string;
  /**
   *
   * @type {AgreementAction}
   * @memberof PersonAgreementInstanceDTO
   */
  agreementAction?: AgreementAction;
  /**
   *
   * @type {boolean}
   * @memberof PersonAgreementInstanceDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonAgreementInstanceDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {AgreementInstanceRef}
   * @memberof PersonAgreementInstanceDTO
   */
  agreementInstanceId: AgreementInstanceRef;
  /**
   *
   * @type {AgreementRef}
   * @memberof PersonAgreementInstanceDTO
   */
  agreementId?: AgreementRef;
  /**
   *
   * @type {PersonRef}
   * @memberof PersonAgreementInstanceDTO
   */
  personId: PersonRef;
}

export interface PersonAgreementInstanceDTOTrackedI extends PersonAgreementInstanceInternalOptional {
  /**
   *
   * @type {number}
   * @memberof PersonAgreementInstanceDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  prefix?: string;
  prefixIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  first?: string;
  firstIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  middle?: string;
  middleIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  last?: string;
  lastIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  suffix?: string;
  suffixIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  preferred?: string;
  preferredIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  organization?: string;
  organizationIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  agreedOn?: Date;
  agreedOnIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  agreementExpiration?: Date;
  agreementExpirationIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  ipAddress?: string;
  ipAddressIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  userAgent?: string;
  userAgentIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonAgreementInstanceDTO
   */
  email?: string;
  emailIsSet: boolean;
  /**
   *
   * @type {AgreementAction}
   * @memberof PersonAgreementInstanceDTO
   */
  agreementAction?: AgreementAction;
  agreementActionIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonAgreementInstanceDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonAgreementInstanceDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {AgreementInstanceRef}
   * @memberof PersonAgreementInstanceDTO
   */
  agreementInstanceId?: AgreementInstanceRefTrackedI;
  agreementInstanceIdIsSet: boolean;
  /**
   *
   * @type {AgreementRef}
   * @memberof PersonAgreementInstanceDTO
   */
  agreementId?: AgreementRefTrackedI;
  agreementIdIsSet: boolean;
  /**
   *
   * @type {PersonRef}
   * @memberof PersonAgreementInstanceDTO
   */
  personId?: PersonRefTrackedI;
  personIdIsSet: boolean;
}

transformDatesMap.set(
  "PersonAgreementInstanceDTO",
  function (model: PersonAgreementInstanceDTO) {
    if (typeof model.agreedOn == "string")
      model.agreedOn = new Date(model.agreedOn);
    if (typeof model.agreementExpiration == "string")
      model.agreementExpiration = new Date(model.agreementExpiration);
    const transformDatesagreementInstanceId = transformDatesMap.get(
      "AgreementInstanceRef",
    );
    if (transformDatesagreementInstanceId && model.agreementInstanceId) {
      transformDatesagreementInstanceId(model.agreementInstanceId);
    }
    const transformDatesagreementId = transformDatesMap.get("AgreementRef");
    if (transformDatesagreementId && model.agreementId) {
      transformDatesagreementId(model.agreementId);
    }
    const transformDatespersonId = transformDatesMap.get("PersonRef");
    if (transformDatespersonId && model.personId) {
      transformDatespersonId(model.personId);
    }
  },
);

export type PersonAgreementInstanceDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  prefix: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  first: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  middle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  last: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  suffix: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  preferred: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  organization: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  agreedOn: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: true
  agreementExpiration: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  ipAddress: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  userAgent: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  email: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  agreementAction: PropertyMeta<AgreementActionMetaI>;
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  agreementInstanceId: PropertyMeta<AgreementInstanceRefMetaI>;
  //isDate: false
  //isDatetime: false
  agreementId: PropertyMeta<AgreementRefMetaI>;
  //isDate: false
  //isDatetime: false
  personId: PropertyMeta<PersonRefMetaI>;
}>;

export var PersonAgreementInstanceDTOMeta: PersonAgreementInstanceDTOMetaI =
  {} as PersonAgreementInstanceDTOMetaI;
PersonAgreementInstanceDTOMeta = typeMeta("PersonAgreementInstanceDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  prefix: propertyMeta("prefix", false, false, false, MetaTypesBase.string),
  first: propertyMeta("first", false, false, false, MetaTypesBase.string),
  middle: propertyMeta("middle", false, false, false, MetaTypesBase.string),
  last: propertyMeta("last", false, false, false, MetaTypesBase.string),
  suffix: propertyMeta("suffix", false, false, false, MetaTypesBase.string),
  preferred: propertyMeta(
    "preferred",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  organization: propertyMeta(
    "organization",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  agreedOn: propertyMeta("agreedOn", false, false, false, MetaTypesBase.Date),
  agreementExpiration: propertyMeta(
    "agreementExpiration",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  ipAddress: propertyMeta(
    "ipAddress",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  userAgent: propertyMeta(
    "userAgent",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  email: propertyMeta("email", false, false, false, MetaTypesBase.string),
  agreementAction: propertyMeta(
    "agreementAction",
    false,
    false,
    false,
    AgreementActionMeta,
  ),
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  agreementInstanceId: propertyMeta(
    "agreementInstanceId",
    false,
    true,
    false,
    AgreementInstanceRefMeta,
  ),
  agreementId: propertyMeta(
    "agreementId",
    false,
    false,
    false,
    AgreementRefMeta,
  ),
  personId: propertyMeta("personId", false, true, false, PersonRefMeta),
});

const metaI = PersonAgreementInstanceDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([
    PersonAgreementInstanceInternalMeta,
  ]);
  metaI.assignId.inheritedFrom = PersonAgreementInstanceInternalMeta.assignId;
  metaI.prefix.inheritedFrom = PersonAgreementInstanceInternalMeta.prefix;
  metaI.first.inheritedFrom = PersonAgreementInstanceInternalMeta.first;
  metaI.middle.inheritedFrom = PersonAgreementInstanceInternalMeta.middle;
  metaI.last.inheritedFrom = PersonAgreementInstanceInternalMeta.last;
  metaI.suffix.inheritedFrom = PersonAgreementInstanceInternalMeta.suffix;
  metaI.preferred.inheritedFrom = PersonAgreementInstanceInternalMeta.preferred;
  metaI.organization.inheritedFrom =
    PersonAgreementInstanceInternalMeta.organization;
  metaI.agreedOn.inheritedFrom = PersonAgreementInstanceInternalMeta.agreedOn;
  metaI.agreementExpiration.inheritedFrom =
    PersonAgreementInstanceInternalMeta.agreementExpiration;
  metaI.ipAddress.inheritedFrom = PersonAgreementInstanceInternalMeta.ipAddress;
  metaI.userAgent.inheritedFrom = PersonAgreementInstanceInternalMeta.userAgent;
  metaI.email.inheritedFrom = PersonAgreementInstanceInternalMeta.email;
  metaI.agreementAction.inheritedFrom =
    PersonAgreementInstanceInternalMeta.agreementAction;
  metaI.isDeleted.inheritedFrom = PersonAgreementInstanceInternalMeta.isDeleted;
  metaI.isNew.inheritedFrom = PersonAgreementInstanceInternalMeta.isNew;
  metaI.agreementInstanceId.inheritedFrom =
    PersonAgreementInstanceInternalMeta.agreementInstanceId;
  metaI.agreementId.inheritedFrom =
    PersonAgreementInstanceInternalMeta.agreementId;
  metaI.personId.inheritedFrom = PersonAgreementInstanceInternalMeta.personId;
});

export class PersonAgreementInstanceDTOTracked
  extends PersonAgreementInstanceInternalTracked
  implements PersonAgreementInstanceDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  prefix__I?: string = undefined;
  prefixIsSet: boolean = false;
  set prefix(v: undefined | string) {
    if (v !== undefined) {
      this.prefix__I = v;
      this.prefixIsSet = true;
    } else {
      this.prefix__I = v || undefined;
      this.prefixIsSet = false;
    }
    this.changeTracker = true;
  }
  get prefix() {
    return this.prefix__I;
  }
  first__I?: string = undefined;
  firstIsSet: boolean = false;
  set first(v: undefined | string) {
    if (v !== undefined) {
      this.first__I = v;
      this.firstIsSet = true;
    } else {
      this.first__I = v || undefined;
      this.firstIsSet = false;
    }
    this.changeTracker = true;
  }
  get first() {
    return this.first__I;
  }
  middle__I?: string = undefined;
  middleIsSet: boolean = false;
  set middle(v: undefined | string) {
    if (v !== undefined) {
      this.middle__I = v;
      this.middleIsSet = true;
    } else {
      this.middle__I = v || undefined;
      this.middleIsSet = false;
    }
    this.changeTracker = true;
  }
  get middle() {
    return this.middle__I;
  }
  last__I?: string = undefined;
  lastIsSet: boolean = false;
  set last(v: undefined | string) {
    if (v !== undefined) {
      this.last__I = v;
      this.lastIsSet = true;
    } else {
      this.last__I = v || undefined;
      this.lastIsSet = false;
    }
    this.changeTracker = true;
  }
  get last() {
    return this.last__I;
  }
  suffix__I?: string = undefined;
  suffixIsSet: boolean = false;
  set suffix(v: undefined | string) {
    if (v !== undefined) {
      this.suffix__I = v;
      this.suffixIsSet = true;
    } else {
      this.suffix__I = v || undefined;
      this.suffixIsSet = false;
    }
    this.changeTracker = true;
  }
  get suffix() {
    return this.suffix__I;
  }
  preferred__I?: string = undefined;
  preferredIsSet: boolean = false;
  set preferred(v: undefined | string) {
    if (v !== undefined) {
      this.preferred__I = v;
      this.preferredIsSet = true;
    } else {
      this.preferred__I = v || undefined;
      this.preferredIsSet = false;
    }
    this.changeTracker = true;
  }
  get preferred() {
    return this.preferred__I;
  }
  organization__I?: string = undefined;
  organizationIsSet: boolean = false;
  set organization(v: undefined | string) {
    if (v !== undefined) {
      this.organization__I = v;
      this.organizationIsSet = true;
    } else {
      this.organization__I = v || undefined;
      this.organizationIsSet = false;
    }
    this.changeTracker = true;
  }
  get organization() {
    return this.organization__I;
  }
  agreedOn__I?: Date = undefined;
  agreedOnIsSet: boolean = false;
  set agreedOn(v: undefined | Date) {
    if (v !== undefined) {
      this.agreedOn__I = v;
      this.agreedOnIsSet = true;
    } else {
      this.agreedOn__I = v || undefined;
      this.agreedOnIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreedOn() {
    return this.agreedOn__I;
  }
  agreementExpiration__I?: Date = undefined;
  agreementExpirationIsSet: boolean = false;
  set agreementExpiration(v: undefined | Date) {
    if (v !== undefined) {
      this.agreementExpiration__I = v;
      this.agreementExpirationIsSet = true;
    } else {
      this.agreementExpiration__I = v || undefined;
      this.agreementExpirationIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementExpiration() {
    return this.agreementExpiration__I;
  }
  ipAddress__I?: string = undefined;
  ipAddressIsSet: boolean = false;
  set ipAddress(v: undefined | string) {
    if (v !== undefined) {
      this.ipAddress__I = v;
      this.ipAddressIsSet = true;
    } else {
      this.ipAddress__I = v || undefined;
      this.ipAddressIsSet = false;
    }
    this.changeTracker = true;
  }
  get ipAddress() {
    return this.ipAddress__I;
  }
  userAgent__I?: string = undefined;
  userAgentIsSet: boolean = false;
  set userAgent(v: undefined | string) {
    if (v !== undefined) {
      this.userAgent__I = v;
      this.userAgentIsSet = true;
    } else {
      this.userAgent__I = v || undefined;
      this.userAgentIsSet = false;
    }
    this.changeTracker = true;
  }
  get userAgent() {
    return this.userAgent__I;
  }
  email__I?: string = undefined;
  emailIsSet: boolean = false;
  set email(v: undefined | string) {
    if (v !== undefined) {
      this.email__I = v;
      this.emailIsSet = true;
    } else {
      this.email__I = v || undefined;
      this.emailIsSet = false;
    }
    this.changeTracker = true;
  }
  get email() {
    return this.email__I;
  }
  agreementAction__I?: AgreementAction = undefined;
  agreementActionIsSet: boolean = false;
  set agreementAction(v: undefined | AgreementAction) {
    if (v !== undefined) {
      this.agreementAction__I = v;
      this.agreementActionIsSet = true;
    } else {
      this.agreementAction__I = v || undefined;
      this.agreementActionIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementAction() {
    return this.agreementAction__I;
  }
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  agreementInstanceId__I?: AgreementInstanceRefTracked = undefined;
  agreementInstanceIdIsSet: boolean = false;
  set agreementInstanceId(v: undefined | AgreementInstanceRefTracked) {
    if (v !== undefined) {
      this.agreementInstanceId__I = v;
      this.agreementInstanceIdIsSet = true;
    } else {
      this.agreementInstanceId__I = v || undefined;
      this.agreementInstanceIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get agreementInstanceId() {
    return this.agreementInstanceId__I;
  }
  agreementId__I?: AgreementRefTracked = undefined;
  agreementIdIsSet: boolean = false;
  set agreementId(v: undefined | AgreementRefTracked) {
    if (v !== undefined) {
      this.agreementId__I = v;
      this.agreementIdIsSet = true;
    } else {
      this.agreementId__I = v || undefined;
      this.agreementIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get agreementId() {
    return this.agreementId__I;
  }
  personId__I?: PersonRefTracked = undefined;
  personIdIsSet: boolean = false;
  set personId(v: undefined | PersonRefTracked) {
    if (v !== undefined) {
      this.personId__I = v;
      this.personIdIsSet = true;
    } else {
      this.personId__I = v || undefined;
      this.personIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get personId() {
    return this.personId__I;
  }
  constructor(
    config?: PersonAgreementInstanceDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.agreementInstanceId?.setIds();

    this.agreementId?.setIds();

    this.personId?.setIds();
  }
  assignFrom(
    config: PersonAgreementInstanceDTOOptional,
    options?: AssignOptions,
  ): PersonAgreementInstanceDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.prefix && this.prefixApplyFilter(optionsRequired.filter)) {
      this.prefix = config.prefix;
      if (optionsRequired.unassign) this.prefixIsSet = false;
      else this.prefixIsSet = true;
    }
    if (config.first && this.firstApplyFilter(optionsRequired.filter)) {
      this.first = config.first;
      if (optionsRequired.unassign) this.firstIsSet = false;
      else this.firstIsSet = true;
    }
    if (config.middle && this.middleApplyFilter(optionsRequired.filter)) {
      this.middle = config.middle;
      if (optionsRequired.unassign) this.middleIsSet = false;
      else this.middleIsSet = true;
    }
    if (config.last && this.lastApplyFilter(optionsRequired.filter)) {
      this.last = config.last;
      if (optionsRequired.unassign) this.lastIsSet = false;
      else this.lastIsSet = true;
    }
    if (config.suffix && this.suffixApplyFilter(optionsRequired.filter)) {
      this.suffix = config.suffix;
      if (optionsRequired.unassign) this.suffixIsSet = false;
      else this.suffixIsSet = true;
    }
    if (config.preferred && this.preferredApplyFilter(optionsRequired.filter)) {
      this.preferred = config.preferred;
      if (optionsRequired.unassign) this.preferredIsSet = false;
      else this.preferredIsSet = true;
    }
    if (
      config.organization &&
      this.organizationApplyFilter(optionsRequired.filter)
    ) {
      this.organization = config.organization;
      if (optionsRequired.unassign) this.organizationIsSet = false;
      else this.organizationIsSet = true;
    }
    if (config.agreedOn && this.agreedOnApplyFilter(optionsRequired.filter)) {
      this.agreedOn = config.agreedOn;
      if (optionsRequired.unassign) this.agreedOnIsSet = false;
      else this.agreedOnIsSet = true;
    }
    if (
      config.agreementExpiration &&
      this.agreementExpirationApplyFilter(optionsRequired.filter)
    ) {
      this.agreementExpiration = config.agreementExpiration;
      if (optionsRequired.unassign) this.agreementExpirationIsSet = false;
      else this.agreementExpirationIsSet = true;
    }
    if (config.ipAddress && this.ipAddressApplyFilter(optionsRequired.filter)) {
      this.ipAddress = config.ipAddress;
      if (optionsRequired.unassign) this.ipAddressIsSet = false;
      else this.ipAddressIsSet = true;
    }
    if (config.userAgent && this.userAgentApplyFilter(optionsRequired.filter)) {
      this.userAgent = config.userAgent;
      if (optionsRequired.unassign) this.userAgentIsSet = false;
      else this.userAgentIsSet = true;
    }
    if (config.email && this.emailApplyFilter(optionsRequired.filter)) {
      this.email = config.email;
      if (optionsRequired.unassign) this.emailIsSet = false;
      else this.emailIsSet = true;
    }
    if (
      config.agreementAction &&
      this.agreementActionApplyFilter(optionsRequired.filter)
    ) {
      this.agreementAction = config.agreementAction;
      if (optionsRequired.unassign) this.agreementActionIsSet = false;
      else this.agreementActionIsSet = true;
    }
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (
      config.agreementInstanceId &&
      this.agreementInstanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.agreementInstanceId = new AgreementInstanceRefTracked(
        config.agreementInstanceId,
        options,
      );
      if (optionsRequired.unassign) this.agreementInstanceIdIsSet = false;
      else this.agreementInstanceIdIsSet = true;
    }
    if (
      config.agreementId &&
      this.agreementIdApplyFilter(optionsRequired.filter)
    ) {
      this.agreementId = new AgreementRefTracked(config.agreementId, options);
      if (optionsRequired.unassign) this.agreementIdIsSet = false;
      else this.agreementIdIsSet = true;
    }
    if (config.personId && this.personIdApplyFilter(optionsRequired.filter)) {
      this.personId = new PersonRefTracked(config.personId, options);
      if (optionsRequired.unassign) this.personIdIsSet = false;
      else this.personIdIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonAgreementInstanceDTOTrackedI {
    const cloned = {} as PersonAgreementInstanceDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.prefixIsSetDeep() &&
      this.prefixApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.prefixIsSet = true;
      cloned.prefix = this.prefix;
    } else {
      //cloned.prefixIsSet = false
    }
    if (
      this.firstIsSetDeep() &&
      this.firstApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.firstIsSet = true;
      cloned.first = this.first;
    } else {
      //cloned.firstIsSet = false
    }
    if (
      this.middleIsSetDeep() &&
      this.middleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.middleIsSet = true;
      cloned.middle = this.middle;
    } else {
      //cloned.middleIsSet = false
    }
    if (
      this.lastIsSetDeep() &&
      this.lastApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lastIsSet = true;
      cloned.last = this.last;
    } else {
      //cloned.lastIsSet = false
    }
    if (
      this.suffixIsSetDeep() &&
      this.suffixApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.suffixIsSet = true;
      cloned.suffix = this.suffix;
    } else {
      //cloned.suffixIsSet = false
    }
    if (
      this.preferredIsSetDeep() &&
      this.preferredApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.preferredIsSet = true;
      cloned.preferred = this.preferred;
    } else {
      //cloned.preferredIsSet = false
    }
    if (
      this.organizationIsSetDeep() &&
      this.organizationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.organizationIsSet = true;
      cloned.organization = this.organization;
    } else {
      //cloned.organizationIsSet = false
    }
    if (
      this.agreedOnIsSetDeep() &&
      this.agreedOnApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreedOnIsSet = true;
      cloned.agreedOn = this.agreedOn;
    } else {
      //cloned.agreedOnIsSet = false
    }
    if (
      this.agreementExpirationIsSetDeep() &&
      this.agreementExpirationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementExpirationIsSet = true;
      cloned.agreementExpiration = this.agreementExpiration;
    } else {
      //cloned.agreementExpirationIsSet = false
    }
    if (
      this.ipAddressIsSetDeep() &&
      this.ipAddressApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ipAddressIsSet = true;
      cloned.ipAddress = this.ipAddress;
    } else {
      //cloned.ipAddressIsSet = false
    }
    if (
      this.userAgentIsSetDeep() &&
      this.userAgentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.userAgentIsSet = true;
      cloned.userAgent = this.userAgent;
    } else {
      //cloned.userAgentIsSet = false
    }
    if (
      this.emailIsSetDeep() &&
      this.emailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailIsSet = true;
      cloned.email = this.email;
    } else {
      //cloned.emailIsSet = false
    }
    if (
      this.agreementActionIsSetDeep() &&
      this.agreementActionApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementActionIsSet = true;
      cloned.agreementAction = this.agreementAction;
    } else {
      //cloned.agreementActionIsSet = false
    }
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.agreementInstanceIdIsSetDeep() &&
      this.agreementInstanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementInstanceIdIsSet = true;
      cloned.agreementInstanceId =
        this.agreementInstanceId?.removeUnset(filter);
    } else {
      //cloned.agreementInstanceIdIsSet = false
    }
    if (
      this.agreementIdIsSetDeep() &&
      this.agreementIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.agreementIdIsSet = true;
      cloned.agreementId = this.agreementId?.removeUnset(filter);
    } else {
      //cloned.agreementIdIsSet = false
    }
    if (
      this.personIdIsSetDeep() &&
      this.personIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personIdIsSet = true;
      cloned.personId = this.personId?.removeUnset(filter);
    } else {
      //cloned.personIdIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonAgreementInstanceDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.prefixApplyFilter(filter)) this.prefixIsSet = false;

    if (!this.firstApplyFilter(filter)) this.firstIsSet = false;

    if (!this.middleApplyFilter(filter)) this.middleIsSet = false;

    if (!this.lastApplyFilter(filter)) this.lastIsSet = false;

    if (!this.suffixApplyFilter(filter)) this.suffixIsSet = false;

    if (!this.preferredApplyFilter(filter)) this.preferredIsSet = false;

    if (!this.organizationApplyFilter(filter)) this.organizationIsSet = false;

    if (!this.agreedOnApplyFilter(filter)) this.agreedOnIsSet = false;

    if (!this.agreementExpirationApplyFilter(filter))
      this.agreementExpirationIsSet = false;

    if (!this.ipAddressApplyFilter(filter)) this.ipAddressIsSet = false;

    if (!this.userAgentApplyFilter(filter)) this.userAgentIsSet = false;

    if (!this.emailApplyFilter(filter)) this.emailIsSet = false;

    if (!this.agreementActionApplyFilter(filter))
      this.agreementActionIsSet = false;

    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.agreementInstanceIdApplyFilter(filter))
      this.agreementInstanceIdIsSet = false;
    this.agreementInstanceId?.unassignAll(filter);

    if (!this.agreementIdApplyFilter(filter)) this.agreementIdIsSet = false;
    this.agreementId?.unassignAll(filter);

    if (!this.personIdApplyFilter(filter)) this.personIdIsSet = false;
    this.personId?.unassignAll(filter);

    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.assignId,
      PersonAgreementInstanceDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  prefixApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.prefix,
      PersonAgreementInstanceDTOMeta,
      this.prefix,
      this,
    );
  }
  prefixIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.prefixIsSet && this.prefixApplyFilter(filter)) return true;

    return false;
  }
  firstApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.first,
      PersonAgreementInstanceDTOMeta,
      this.first,
      this,
    );
  }
  firstIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.firstIsSet && this.firstApplyFilter(filter)) return true;

    return false;
  }
  middleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.middle,
      PersonAgreementInstanceDTOMeta,
      this.middle,
      this,
    );
  }
  middleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.middleIsSet && this.middleApplyFilter(filter)) return true;

    return false;
  }
  lastApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.last,
      PersonAgreementInstanceDTOMeta,
      this.last,
      this,
    );
  }
  lastIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lastIsSet && this.lastApplyFilter(filter)) return true;

    return false;
  }
  suffixApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.suffix,
      PersonAgreementInstanceDTOMeta,
      this.suffix,
      this,
    );
  }
  suffixIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.suffixIsSet && this.suffixApplyFilter(filter)) return true;

    return false;
  }
  preferredApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.preferred,
      PersonAgreementInstanceDTOMeta,
      this.preferred,
      this,
    );
  }
  preferredIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.preferredIsSet && this.preferredApplyFilter(filter)) return true;

    return false;
  }
  organizationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.organization,
      PersonAgreementInstanceDTOMeta,
      this.organization,
      this,
    );
  }
  organizationIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.organizationIsSet && this.organizationApplyFilter(filter))
      return true;

    return false;
  }
  agreedOnApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.agreedOn,
      PersonAgreementInstanceDTOMeta,
      this.agreedOn,
      this,
    );
  }
  agreedOnIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreedOnIsSet && this.agreedOnApplyFilter(filter)) return true;

    return false;
  }
  agreementExpirationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.agreementExpiration,
      PersonAgreementInstanceDTOMeta,
      this.agreementExpiration,
      this,
    );
  }
  agreementExpirationIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.agreementExpirationIsSet &&
      this.agreementExpirationApplyFilter(filter)
    )
      return true;

    return false;
  }
  ipAddressApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.ipAddress,
      PersonAgreementInstanceDTOMeta,
      this.ipAddress,
      this,
    );
  }
  ipAddressIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ipAddressIsSet && this.ipAddressApplyFilter(filter)) return true;

    return false;
  }
  userAgentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.userAgent,
      PersonAgreementInstanceDTOMeta,
      this.userAgent,
      this,
    );
  }
  userAgentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.userAgentIsSet && this.userAgentApplyFilter(filter)) return true;

    return false;
  }
  emailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.email,
      PersonAgreementInstanceDTOMeta,
      this.email,
      this,
    );
  }
  emailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailIsSet && this.emailApplyFilter(filter)) return true;

    return false;
  }
  agreementActionApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.agreementAction,
      PersonAgreementInstanceDTOMeta,
      this.agreementAction,
      this,
    );
  }
  agreementActionIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementActionIsSet && this.agreementActionApplyFilter(filter))
      return true;

    return false;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.isDeleted,
      PersonAgreementInstanceDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.isNew,
      PersonAgreementInstanceDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  agreementInstanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.agreementInstanceId,
      PersonAgreementInstanceDTOMeta,
      this.agreementInstanceId,
      this,
    );
  }
  agreementInstanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.agreementInstanceIdIsSet &&
      this.agreementInstanceIdApplyFilter(filter)
    )
      return true;
    return this.agreementInstanceId?.anySet(filter) == true;

    return false;
  }
  agreementIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.agreementId,
      PersonAgreementInstanceDTOMeta,
      this.agreementId,
      this,
    );
  }
  agreementIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.agreementIdIsSet && this.agreementIdApplyFilter(filter))
      return true;
    return this.agreementId?.anySet(filter) == true;

    return false;
  }
  personIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonAgreementInstanceDTOMeta.personId,
      PersonAgreementInstanceDTOMeta,
      this.personId,
      this,
    );
  }
  personIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personIdIsSet && this.personIdApplyFilter(filter)) return true;
    return this.personId?.anySet(filter) == true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.prefixIsSetDeep(filter)) return true;
    if (this.firstIsSetDeep(filter)) return true;
    if (this.middleIsSetDeep(filter)) return true;
    if (this.lastIsSetDeep(filter)) return true;
    if (this.suffixIsSetDeep(filter)) return true;
    if (this.preferredIsSetDeep(filter)) return true;
    if (this.organizationIsSetDeep(filter)) return true;
    if (this.agreedOnIsSetDeep(filter)) return true;
    if (this.agreementExpirationIsSetDeep(filter)) return true;
    if (this.ipAddressIsSetDeep(filter)) return true;
    if (this.userAgentIsSetDeep(filter)) return true;
    if (this.emailIsSetDeep(filter)) return true;
    if (this.agreementActionIsSetDeep(filter)) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.agreementInstanceIdIsSetDeep(filter)) return true;
    if (this.agreementIdIsSetDeep(filter)) return true;
    if (this.personIdIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
